import { instance } from "./index";

const getCategories = () => {
    return instance.get(`/category`, { timeout: 0 });
};

const getLinkedCategories = (bannerId) => {
    return instance.get(`/category/registered/${bannerId}`);
};

const categoryManager = {
    getCategories,
    getLinkedCategories,
};

export default categoryManager;
